export default __webpack_public_path__ + "img/pin_icons/flammable_b.png";